
export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="inicio" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Beautiful%20rural%20landscape%20with%20rolling%20green%20hills%2C%20modern%20wind%20turbines%20in%20the%20distance%2C%20sustainable%20agriculture%20fields%2C%20bright%20blue%20sky%20with%20white%20clouds%2C%20representing%20innovation%20and%20sustainability%20in%20rural%20territories%2C%20clean%20and%20inspiring%20atmosphere%2C%20professional%20photography%20style%2C%20high%20contrast%2C%20vibrant%20colors&width=1920&height=1080&seq=hero-territorio360&orientation=landscape')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Innovar en el territorio.<br />
            <span className="text-teal-400">Con visión 360.</span>
          </h1>
          
          <div className="max-w-4xl mx-auto space-y-6 text-lg md:text-xl leading-relaxed">
            <p>
              Hay lugares donde las buenas ideas necesitan raíces. En <strong className="text-teal-400">Territorio360</strong> trabajamos para que la innovación llegue también allí donde empieza todo: en el territorio.
            </p>
            
            <p>
              Acompañamos a empresas, administraciones y personas que creen que el futuro también se construye desde los pueblos. Creamos puentes entre la financiación, la tecnología y la creatividad para impulsar proyectos con impacto real.
            </p>
            
            <p className="text-xl md:text-2xl font-semibold text-teal-400">
              ➡️ Innovar. Conectar. Transformar.<br />
              Eso es <strong>Territorio360</strong>.
            </p>
          </div>

          <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => scrollToSection('quienes-somos')}
              className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Conoce más
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              Únete a la red
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
